/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React from 'react'
import USBNotification from '@usb-shield/react-notification'
import { USBIconClose } from '@usb-shield/react-icons'
import { PropTypes } from 'prop-types'
import { isNullOrEmpty } from '../../../utils/Utility'
import { NotificationVariant } from '../../../utils/messages'

/**
 * Returns 2 USBNotifications, one for errors and one for changes saved successfully.
 * @param {arrayOf(object)} errors - Array of errors
 * @param {string} notificationText - notificationText to display
 * @param {string} notificationVariant - notificationVariant (example: error, warning, confirmation)
 * @param {function} confirmationCloseHandler - event handler when user clicks x on notification
 */
const PageWarning = ({
  errors = [],
  notificationText,
  notificationVariant,
  confirmationCloseHandler,
  status,
  iconAssistiveText
}) => {
  const displayArray = (errs) => {
    if (errs)
      if (Array.isArray(errs))
        if (errors.length > 0)
          if (errors[0] !== undefined) {
            return (
              <>
                <div>
                  <USBNotification
                    variant="error"
                    id="pageErrors"
                    roleType="alert"
                    notificationData={errs}
                  />
                </div>
                &nbsp;
              </>
            )
          }
    return null
  }
  return (
    <>
      {displayArray(errors)}
      {isNullOrEmpty(notificationText) !== '' && (
        <>
          <div>
            <USBNotification
              status={status}
              iconAssistiveText={iconAssistiveText}
              variant={notificationVariant}
              id="confirmation"
              roleType="alert"
              handleClose={
                confirmationCloseHandler !== null || confirmationCloseHandler !== undefined
                  ? confirmationCloseHandler
                  : null
              }
              closeIconNode={<USBIconClose title="Close" />}
              notificationData={[
                {
                  text: notificationText === '' ? 'Changes saved successfully' : notificationText
                }
              ]}
            />
          </div>
          &nbsp;
        </>
      )}
    </>
  )
}

PageWarning.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      linkText: PropTypes.string,
      link: PropTypes.string
    })
  ),
  notificationText: PropTypes.string,
  confirmationCloseHandler: PropTypes.func,
  notificationVariant: PropTypes.oneOf([
    NotificationVariant.confirmation,
    NotificationVariant.warning,
    NotificationVariant.error
  ])
}

PageWarning.defaultProps = {
  notificationText: '',
  confirmationCloseHandler: null,
  notificationVariant: NotificationVariant.confirmation,
  errors: null
}

export default PageWarning
